import { create } from 'zustand';
import apiClient from '../api/client';

interface NotificationStore {
  unread: number;
  /** Re-read GET /notifications/unread-count. Safe to call often; failures keep the last count. */
  refresh: () => Promise<void>;
}

/**
 * Section 28b — the unread badge count, shared between the appbar bell and the Notifications
 * page. The bell used to own this number in local state and only re-poll on its own 60 s tick,
 * so marking a notification read left a stale badge until the next tick or a page reload.
 * Both sides now read the same store and the page refreshes it the moment it marks one read.
 */
export const useNotificationStore = create<NotificationStore>((set) => ({
  unread: 0,

  async refresh() {
    try {
      const { data } = await apiClient.get<{ data: { count: number } }>(
        '/notifications/unread-count'
      );
      set({ unread: data?.data?.count ?? 0 });
    } catch {
      /* transient — keep the last known count, retry on the next tick */
    }
  },
}));
